import { Box } from "@mui/system";
import { useEffect, useState } from "react";

import HorizontalBarChartWithNegative from "../Charts/HorizontalBarChartWithNegative";
import classes from "../../Style/Findings.scss";
import csv from "../../Data/EUMACP/Overview/EU-MACP-Overview-of-samples-with-quantified-residues-above-MRL-and-non-compliant-Stacked-bar-chart.csv";

const Findings = (props) => {
  const fields = [
    "Below LOQ",
    "Between LOQ and MRL",
    "Above MRL",
    "Non-compliant",
  ];

  const colorMap = {
    "Below LOQ": "#00B289",
    "Between LOQ and MRL": "#9CDCCE",
    "Above MRL": "#FFCE3A",
    "Non-compliant": "#EF9800",
  };

  const retained = "Food commodity";

  const findings = [
    {
      title: "Total no. of samples",
      value: "9,842",
      sup: undefined,
      color: undefined,
    },
    {
      title: "Below LOQ",
      value: "4,241",
      sup: "43.1%",
      color: "#00B289",
    },
    {
      title: "Between LOQ & MRL",
      value: "5,367",
      sup: "54.5%",
      color: "#9CDCCE",
    },
    {
      title: "Above MRL",
      value: "234",
      sup: "2.4%",
      color: "#FFCE3A",
    },
    {
      title: "Non-compliant",
      value: "113",
      sup: "1.2%",
      color: "#EF9800",
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <Box>
      <Box
        sx={{ marginBottom: "2rem", display: "flex", flexWrap: "wrap" }}
        className="findingsWrapper"
        justifyContent={{ xs: "start", sm: "start", md: "space-between" }}
      >
        {findings.map((f) => {
          const border = f.color ? `3px ${f.color} solid` : "";
          return (
            <Box
              key={f.title}
              className="finding"
              pl={1}
              sx={{ borderLeft: border }}
            >
              <p>{f.title}</p>
              <h3>
                {f.value}
                {f.sup && <sup>({f.sup})</sup>}
              </h3>
            </Box>
          );
        })}
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "column", md: "row" }}
      >
        <Box flexGrow={3} order={{ xs: 2, sm: 2, md: 1 }}>
          <HorizontalBarChartWithNegative
            title={"Percentage of samples below/at the MRL, above the MRL, and non‑compliant"}
            chartImg={props.chartImg}
            height={400}
            padding={isMobile ? "auto" : [15, 30, 60, 120]}
            colorMap={colorMap}
            fields={fields}
            retained={retained}
            csv={csv}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Findings;
